import { render, staticRenderFns } from "./plan-objetivos.vue?vue&type=template&id=fb3fd416&scoped=true&"
import script from "./plan-objetivos.vue?vue&type=script&lang=js&"
export * from "./plan-objetivos.vue?vue&type=script&lang=js&"
import style0 from "./plan-objetivos.vue?vue&type=style&index=0&id=fb3fd416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3fd416",
  null
  
)

export default component.exports